import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RESOURCES } from 'OpsCenter/app.constants';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';


export default function domainService($http, RESOURCES) {
  let service;

  service = {
    getLocales: getLocales,
    getSalutations: getSalutations,
  };

  return service;

  function getLocales(countryId) {
    return $http.get(RESOURCES.DOMAIN + '/locales', {
      params: {
        countryId: countryId,
      },
    });
  }

  function getSalutations(countryId) {
    return $http.get(RESOURCES.DOMAIN + '/salutations', {
      params: {
        countryId: countryId,
      },
    });
  }
}

/** @desc Migrated service function **/
@Injectable()
export class DomainService {
  constructor(private http: HttpClient) {}

  /**
   * @desc Function to get locals based on the country id
   * @param {string} countryId - Id of the country which locale should be retrieved
   * @return {Observable}
   */
  getLocales(countryId: string): Observable<any> {
    return this.http
      .get(RESOURCES.DOMAIN + '/locales', {
        params: {
          countryId: countryId,
        },
      })
      .pipe(map(res => <any>res));
  }

  /**
   * @desc Function to get salutations ref list based on country id
   * @param {string} countryId - Id of the country which saluatations should be retrieved
   * @return {Observable}
   */
  getSalutations(countryId: string): Observable<any> {
    return this.http
      .get(RESOURCES.DOMAIN + '/salutations', {
        params: {
          countryId: countryId,
        },
      })
      .pipe(map(res => <any>res));
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/domain.service.ts